import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import * as React from "react";
import styles from './styles.module.sass';

export interface ISelectItemData {
    label: string;
    value: any;
}

interface IProps {
    options: ISelectItemData[],
    start: any,
    onChange: (input: any) => void,
    shadow: boolean,
    error?: boolean;
    value?: { label: string, value: string }

}

interface IState {
    dropDownOpen: boolean,
    current: string,
}

export class CustomDropDown extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.select = this.select.bind(this);
        this.state = {
            dropDownOpen: false,
            current: this.props.start.label
        };
    }

    public toggle() {
        this.setState(prevState => ({
            dropDownOpen: !prevState.dropDownOpen
        }));
    }


    public select(option: { label: string; value: string }) {
        this.setState({
            current: option.label,
        });
        this.props.onChange(option);
    }

    public render() {
        const {shadow, options, error} = this.props;
        const {dropDownOpen, current} = this.state;
        return (
            <Dropdown isOpen={dropDownOpen} toggle={this.toggle}>
                <DropdownToggle
                    className={shadow ? error ? styles.switchError : styles.switch : error ? styles.switchNoShadowError : styles.switchNoShadow}
                    caret={true}>
                    {current}
                </DropdownToggle>

                <DropdownMenu className={shadow ? styles.menuWrapper : styles.menuWrapperNoShadow}>
                    {options.map(opt => {
                        return <DropdownItem key={opt.value} onClick={this.select.bind(this, opt)}
                                             className={styles.item}>{opt.label}</DropdownItem>
                    })}
                </DropdownMenu>
            </Dropdown>

        );
    }
}
